//vue
import Vue from 'vue';
import VueRouter from 'vue-router';
//base
import Login from '../views/Login.vue';
import Home from '../views/Home.vue';
//client
import ClientIndex from '../views/client/Index.vue';
import ClientList from '../views/client/List.vue';
import ClientForm from '../views/client/Form.vue';
//contract
import ContractIndex from '../views/contract/Index.vue';
import ContractList from '../views/contract/List.vue';
//lead
import LeadIndex from '../views/lead/Index.vue';
import LeadList from '../views/lead/List.vue';
//afiliado
import AfiliadoIndex from '../views/afiliado/Index.vue';
import AfiliadoList from '../views/afiliado/List.vue';
import AfiliadoForm from '../views/afiliado/Form.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: "/home"
  },
  {
    path: '/login',
    component: Login 
  },
  {
    path: '/home',
    component: Home
  },
  {
    path: '/client',
    component: ClientIndex,
    children: [
      {
        path: "/",
        component: ClientList
      },
      {
        path: ":id",
        component: ClientForm
      }
    ]
  },
  {
    path: '/contract',
    component: ContractIndex,
    children: [
      {
        path: "/",
        component: ContractList
      }
    ]
  },
  {
    path: '/lead',
    component: LeadIndex,
    children: [
      {
        path: "/",
        component: LeadList
      }
    ]
  },
  {
    path: '/afiliado',
    component: AfiliadoIndex,
    children: [
      {
        path: "/",
        component: AfiliadoList
      },
      {
        path: ":id",
        component: AfiliadoForm
      }
    ]
  }
];

const router = new VueRouter({
  routes
});

export default router;
